
























import { Component, Vue } from 'vue-property-decorator';
import LangSelect from '@/components/global/LangSelect/index.vue';
import ThemeSelect from '@/components/global/ThemeSelect/index.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { clearUserRelatedStates } from '@/utils/app';

@Component({
  name: 'AppNavbarMenu',
  components: {
    LangSelect,
    ThemeSelect,
  },
})
export default class extends Vue {
  get username() {
    return UserModule.name;
  }

  // TODO: delete
  private async logout() {
    AppModule.StartProgress();
    try {
      await UserModule.Logout();
      clearUserRelatedStates();
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    } catch (err) {
      AppModule.StopProgress();
      this.$toast.error(`logout: ${err}`, {
        icon: 'mdi-account-alert',
      });
    }
  }
}
